export const sanitize = (value) => {
    if (!value || value === '') {
        return '';
    }
    // replace & first for this to work
    return value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
};
